// assets/cart-fly.js
// ======================================================
// Animação "ghost" do produto voando até a sacola
// + contador otimista (atualiza na hora, corrige quando o servidor responder)
// Desktop: voa até #cart-icon-bubble no header
// Mobile:  voa até a sacola do navbar inferior (#sticky-menu)
// ======================================================
(function () {
  if (window.IallyCartFly) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = function () { return window.matchMedia('(max-width: 768px)').matches; };

  function navbarTarget() {
    var nav = document.getElementById('sticky-menu');
    if (!nav) return null;
    var cs = window.getComputedStyle(nav);
    if (cs.display === 'none' || cs.visibility === 'hidden') return null;
    var el = nav.querySelector('.cart-link-item .svg-wrapper') || nav.querySelector('.cart-link-item');
    if (!el) return null;
    var hiddenOffset = 0;
    if (nav.classList.contains('is-scrolled-away')) {
      hiddenOffset = nav.offsetHeight + 2;
      nav.classList.remove('is-scrolled-away'); // mostra o navbar para receber o produto
    }
    return { el: el, offsetY: -hiddenOffset };
  }

  function headerTarget() {
    var el = document.querySelector('#cart-icon-bubble .svg-wrapper') || document.getElementById('cart-icon-bubble');
    return el ? { el: el, offsetY: 0 } : null;
  }

  function getTarget() {
    return (isMobile() && navbarTarget()) || headerTarget() || navbarTarget();
  }

  function pulse(el) {
    if (!el || !el.animate || reduceMotion) return;
    el.animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(1.22)' }, { transform: 'scale(.96)' }, { transform: 'scale(1)' }],
      { duration: 420, easing: 'cubic-bezier(.2,.7,.2,1)' }
    );
  }

  // ---------- contador ----------
  function readCount() {
    var b = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    var n = b ? (b.style.display === 'none' ? 0 : parseInt((b.textContent || '').trim() || '0', 10)) : NaN;
    if (isNaN(n)) {
      var nb = document.querySelector('#sticky-menu .cart-count-bubble-navbar span');
      n = nb ? parseInt(nb.textContent || '0', 10) : 0;
    }
    return isNaN(n) ? 0 : n;
  }

  function setCount(n) {
    n = Math.max(0, n | 0);
    var text = n < 100 ? String(n) : '99+';

    var host = document.getElementById('cart-icon-bubble');
    if (host) {
      var b = host.querySelector('.cart-count-bubble');
      if (!b && n > 0) {
        b = document.createElement('span');
        b.className = 'cart-count-bubble';
        (host.querySelector('.svg-wrapper') || host).appendChild(b);
      }
      if (b) {
        b.textContent = n > 0 ? text : '';
        b.setAttribute('data-count', String(n));
        b.style.display = n > 0 ? '' : 'none';
      }
    }

    var nb = document.querySelector('#sticky-menu .cart-count-bubble-navbar');
    if (nb) {
      var span = nb.querySelector('span');
      if (span) span.textContent = text;
      nb.classList.toggle('hidden', n === 0);
      nb.style.display = n > 0 ? 'flex' : 'none';
    }
  }

  function bump(delta) {
    setCount(readCount() + (delta || 0));
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    var nbubble = document.querySelector('#sticky-menu .cart-count-bubble-navbar');
    pulse(isMobile() && nbubble ? nbubble : bubble);
  }

  // ---------- voo ----------
  function fly(sourceImg) {
    return new Promise(function (resolve) {
      var t = getTarget();
      if (!sourceImg || !t || reduceMotion || !document.body.animate) {
        if (t) pulse(t.el);
        resolve();
        return;
      }

      var s = sourceImg.getBoundingClientRect();
      var tr = t.el.getBoundingClientRect();
      if (!s.width || !s.height) { pulse(t.el); resolve(); return; }

      // recorte quadrado central da foto, para encolher sem distorcer
      var side = Math.min(s.width, s.height);
      var sx = s.left + (s.width - side) / 2;
      var sy = s.top + (s.height - side) / 2;

      var tx = tr.left + tr.width / 2;
      var ty = tr.top + tr.height / 2 + t.offsetY;
      // header fora da tela (desktop rolado): mira no topo visível
      ty = Math.min(Math.max(ty, 14), window.innerHeight - 14);
      tx = Math.min(Math.max(tx, 14), window.innerWidth - 14);

      var dx = tx - (sx + side / 2);
      var dy = ty - (sy + side / 2);
      var endScale = 26 / side;

      var ghost = document.createElement('div');
      ghost.className = 'cp-fly-ghost';
      ghost.setAttribute('aria-hidden', 'true');
      ghost.style.cssText =
        'left:' + sx + 'px;top:' + sy + 'px;width:' + side + 'px;height:' + side + 'px;' +
        "background-image:url('" + (sourceImg.currentSrc || sourceImg.src) + "');";
      document.body.appendChild(ghost);

      // arco: curva quadrática com ponto de controle acima da linha reta
      var lift = Math.min(160, Math.abs(dx) * 0.35 + 60);
      var cx = dx * 0.5, cy = Math.min(0, dy) - lift;
      var frames = [];
      var steps = 10;
      for (var i = 0; i <= steps; i++) {
        var p = i / steps;
        var x = 2 * (1 - p) * p * cx + p * p * dx;
        var y = 2 * (1 - p) * p * cy + p * p * dy;
        var sc = 1 + (endScale - 1) * Math.pow(p, 0.8);
        if (i === 1) sc = 0.94; // pequeno "respiro" ao sair do card
        frames.push({
          transform: 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) scale(' + sc.toFixed(3) + ')',
          opacity: (p < 0.15 ? 0.92 : 0.92 - 0.72 * p).toFixed(2),
          borderRadius: (4 + 46 * p).toFixed(1) + '%',
          filter: 'blur(' + (p * 1.2).toFixed(2) + 'px) saturate(' + (1 - 0.3 * p).toFixed(2) + ')'
        });
      }

      // a foto original "deixa" o fantasma: escurece e volta
      if (sourceImg.animate) {
        sourceImg.animate([{ opacity: 1 }, { opacity: 0.55 }, { opacity: 1 }], { duration: 520, easing: 'ease-out' });
      }

      var duration = isMobile() ? 640 : 760;
      var anim = ghost.animate(frames, { duration: duration, easing: 'cubic-bezier(.55,.06,.68,.19)', fill: 'forwards' });
      var done = function () {
        ghost.remove();
        pulse(t.el);
        resolve();
      };
      anim.onfinish = done;
      anim.oncancel = done;
      setTimeout(function () { if (ghost.isConnected) done(); }, duration + 300);
    });
  }

  window.IallyCartFly = { fly: fly, bump: bump, setCount: setCount, readCount: readCount, pulse: pulse };
})();
